const config = {
  initiateLoginEndpoint: process.env.REACT_APP_START_LOGIN_PAGE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  baseURLEndpoint: process.env.REACT_APP_BASE_URL_ENDPOINT,
  loginEndpoint: process.env.REACT_APP_LOGIN_ENDPOINT,
  clientSecret: process.env.REACT_APP_CLIENT_SECRET,
  featureFlags: process.env.REACT_APP_FEATURE_FLAGS ?? '{}',
  leadRoleId: process.env.REACT_APP_LEADER_ROLE_ID ?? '',
  managerRoleId: process.env.REACT_APP_MANAGER_ROLE_ID ?? '',
  countlyAppKey: process.env.REACT_APP_COUNTLY_APP_KEY ?? '',
  countlyUrl: process.env.REACT_APP_COUNTLY_URL ?? '',
  teamsAppId: process.env.REACT_APP_TEAMS_APP_ID ?? '',
  demoUserId: process.env.REACT_APP_DEMO_USER_ID ?? '',
};

export default config;
